// extracted by mini-css-extract-plugin
export default {"colorContainer":"choose-color__colorContainer___aIhtL","disabled":"choose-color__disabled___LYHBz","toggleBackgroundOrange":"choose-color__toggleBackgroundOrange___du1Lc"};